import { createFileRoute } from "@tanstack/react-router";
import { Mail, MapPin, Phone } from "lucide-react";
import { PageHero } from "@/components/site/PageHero";
import { ContactForm } from "@/components/site/ContactForm";
import Logo from "@/assets/schober//logo-weiss.webp";
export const Route = createFileRoute("/kontakt")({
  head: () => ({
    meta: [
      { title: "Kontakt – Schober Transportservice" },
      {
        name: "description",
        content:
          "Kontaktieren Sie Schober Transportservice. Heuweg 5/2, 2721 Bad Fischau · +43 680 23 08 700 · office@schober-transportservice.at",
      },
      { property: "og:title", content: "Kontakt – Schober Transportservice" },
      {
        property: "og:description",
        content: "Wir helfen gerne – nehmen Sie Kontakt auf!",
      },
    ],
  }),
  component: KontaktPage,
});

function KontaktPage() {
  return (
    <>
      <PageHero title="KONTAKT" subtitle="Wir helfen gerne" />

      <section className="container mx-auto max-w-7xl grid gap-12 px-4 py-20 lg:grid-cols-[35%_65%]">
        <div className="bg-brand-navy p-15">
          <h2 className="font-display text-3xl font-extrabold text-white md:text-4xl">
            KONTAKT AUFNEHMEN
          </h2>
          <p className="mt-4 text-white/80">
            Wir freuen uns auf Ihre Anfrage und melden uns rasch bei Ihnen mit
            einem unverbindlichen Angebot.
          </p>

          <ul className="mt-8 space-y-5">
            <li className="flex items-start gap-4">
              <span className="flex h-11 w-11 flex-none items-center justify-center rounded-full bg-brand-orange/10 text-brand-orange">
                <MapPin className="h-5 w-5" />
              </span>
              <div>
                <p className="text-sm font-semibold text-white">Adresse</p>
                <p className="text-white/80">Heuweg 5/2, 2721 Bad Fischau</p>
              </div>
            </li>
            <li className="flex items-start gap-4">
              <span className="flex h-11 w-11 flex-none items-center justify-center rounded-full bg-brand-orange/10 text-brand-orange">
                <Phone className="h-5 w-5" />
              </span>
              <div>
                <p className="text-sm font-semibold text-white">Telefon</p>
                <a
                  href="tel:00436802308700"
                  className="text-white/80 hover:text-brand-orange"
                >
                  +43 680 23 08 700
                </a>
              </div>
            </li>
            <li className="flex items-start gap-4">
              <span className="flex h-11 w-11 flex-none items-center justify-center rounded-full bg-brand-orange/10 text-brand-orange">
                <Mail className="h-5 w-5" />
              </span>
              <div>
                <p className="text-sm font-semibold text-white">E-Mail</p>
                <a
                  href="mailto:office@schober-transportservice.at"
                  className="break-all text-white/80 hover:text-brand-orange"
                >
                  office@schober-transportservice.at
                </a>
              </div>
            </li>
            <li>
              <img src={Logo} alt="Schober Transportservice Logo" loading="lazy" decoding="async" className="mt-10 w-full" />
            </li>
          </ul>
        </div>

        <div className="">
          <h3 className="font-display text-2xl font-bold text-brand-navy">
            SCHREIBEN SIE UNS
          </h3>
          <p className="mt-1 text-sm text-black/70">
            Füllen Sie das Formular aus – wir antworten umgehend.
          </p>
          <div className="mt-6">
            <ContactForm variant="light" />
          </div>
        </div>
      </section>

      <section className="bg-muted">
        <div className="container mx-auto max-w-7xl px-4 py-16 md:py-20 grid gap-10 md:grid-cols-3">
          <article>
            <h2 className="font-display text-2xl font-bold text-brand-navy">So erreichen Sie uns am schnellsten</h2>
            <p className="mt-3 text-foreground/80">
              Am schnellsten geht es telefonisch unter <a href="tel:00436802308700" className="font-semibold text-brand-orange">+43 680 23 08 700</a>.
              Patric Schober ist persönlich Mo–Sa von 7:00 bis 20:00 erreichbar. Für eine
              kostenlose Besichtigung mit Angebot reicht ein kurzer Anruf
              oder das Formular auf dieser Seite.
            </p>
            <p className="mt-3 text-foreground/80">
              Wir antworten auf E-Mails an{' '}
              <a href="mailto:office@schober-transportservice.at" className="font-semibold text-brand-orange">office@schober-transportservice.at</a>{' '}
              in der Regel innerhalb von 2 Stunden während der Geschäftszeiten.
            </p>
          </article>
          <article>
            <h2 className="font-display text-2xl font-bold text-brand-navy">Einsatzgebiet</h2>
            <p className="mt-3 text-foreground/80">
              Unser Standort ist Bad Fischau in Niederösterreich. Von dort aus übersiedeln
              und entrümpeln wir täglich in Wien (alle 23 Bezirke), Niederösterreich
              (Mödling, Baden, Wiener Neustadt, St. Pölten, Tulln, Krems, Korneuburg,
              Gänserndorf, Bruck a. d. Leitha) sowie im nördlichen Burgenland
              (Eisenstadt, Neusiedl, Mattersburg). Bundesweite Transporte und Umzüge
              nach Graz, Linz, Salzburg, Klagenfurt oder Innsbruck sind nach Absprache
              möglich.
            </p>
          </article>
          <article>
            <h2 className="font-display text-2xl font-bold text-brand-navy">Was Sie für ein präzises Angebot bereit halten</h2>
            <ul className="mt-3 list-disc pl-5 space-y-1 text-foreground/80">
              <li>Adresse von Auszug und Einzug (inkl. Stockwerk und Lift ja/nein)</li>
              <li>Wohnungsgröße in m² oder ungefähre Anzahl der Zimmer</li>
              <li>Wunschtermin oder Zeitfenster (Wochenende oft teurer als Wochenmitte)</li>
              <li>Besondere Stücke: Klavier, Tresor, Aquarium, große Glasflächen</li>
              <li>Halteverbotszone bereits beantragt – ja oder bitte mitübernehmen?</li>
              <li>Sollen alte Möbel geräumt und abtransportiert werden?</li>
            </ul>
            <p className="mt-3 text-foreground/80">
              Mit diesen Angaben können wir bereits am Telefon einen seriösen Richtpreis
              nennen. Für den verbindlichen Angebot kommen wir kostenlos vor Ort vorbei.
            </p>
          </article>
        </div>
      </section>
    </>
  );
}
